var map = {
	"./amazonMusicUrl_img.png": 46403,
	"./amazon_music_img.png": 52459,
	"./anghmiUrl_img.png": 40674,
	"./appleMusicUrl_img.png": 78974,
	"./apple_music_img.png": 67710,
	"./bugsUrl_img.png": 85759,
	"./bugs_img.png": 9185,
	"./bugs_trend_img.png": 75115,
	"./deezerUrl_img.png": 42269,
	"./etc_img.png": 95974,
	"./floUrl_img.png": 59048,
	"./genieUrl_img.png": 34274,
	"./genie_img.png": 24523,
	"./genie_trend_img.png": 83399,
	"./jooxUrl_img.png": 94312,
	"./jp_img.png": 78146,
	"./kkboxUrl_img.png": 87596,
	"./linejpUrl_img.png": 33462,
	"./linetwUrl_img.png": 82041,
	"./melonUrl_img.png": 70329,
	"./melon_img.png": 69877,
	"./melon_trend_img.png": 31289,
	"./mymusicUrl_img.png": 42739,
	"./nctUrl_img.png": 9534,
	"./spotifyUrl_img.png": 59847,
	"./spotify_trend_img.png": 77320,
	"./tidalUrl_img.png": 19625,
	"./tw_img.png": 30386,
	"./vibeUrl_img.png": 36345,
	"./yandexUrl_img.png": 84109,
	"./youtubeMusicUrl_img.png": 28983,
	"./youtube_img.png": 26924,
	"./youtube_trend_img.png": 20277,
	"./zingUrl_img.png": 45095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53810;